if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.#init();
    }

    #init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingSuccess = false

      if ( freeShippingRemaining < 0 ) {
       shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace(
  '{{ remaining_amount }}',
  this.#formatMoney(Math.abs(freeShippingRemaining), '{{ amount_with_comma_separator }} €*')
);

      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      
const threshold = Math.round(
  freeShippingThreshold *
  (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
);

const progress = threshold > 0
  ? Math.min(100, Math.max(0, (cartTotal / threshold) * 100))
  : 100;

const formattedTotal = this.#formatMoney(
  cartTotal,
  '{{ amount_with_comma_separator }} €'
);

const formattedThreshold = this.#formatMoney(
  threshold,
  '{{ amount_with_comma_separator }} €'
);

const textColor = this.hasAttribute('data-show-alert') ? '#222222' : '#ffffff';



const progressMarkup = `
  <div class="mgw-shipping-progress"
       style="display:block;width:100%;">

    <div style="
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:12px;
      margin-bottom:12px;
      color:${this.hasAttribute('data-show-alert') ? '#222222' : '#ffffff'};
      font-size:13px;
      line-height:1.5;
    ">
      <span>
        ${shippingSuccess
          ? 'Super! Ihr Versand ist kostenlos.'
          : `Noch <strong>${this.#formatMoney(
              Math.max(0, threshold - cartTotal),
              '{{ amount_with_comma_separator }} €'
            )}</strong> bis zum kostenlosen Versand`
        }
      </span>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="${this.hasAttribute('data-show-alert') ? '#222222' : '#ffffff'}"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        style="flex-shrink:0;"
      >
        ${shippingSuccess
          ? `<circle cx="12" cy="12" r="10"/>
             <path d="m8 12 2.5 2.5L16 9"/>`
          : `<path d="M10 17h4V5H2v12h3"/>
             <path d="M14 9h4l4 4v4h-3"/>
             <circle cx="7.5" cy="17.5" r="2.5"/>
             <circle cx="16.5" cy="17.5" r="2.5"/>`
        }
      </svg>
    </div>

    <div
      role="progressbar"
      aria-label="Fortschritt bis zum kostenlosen Versand"
      aria-valuemin="0"
      aria-valuemax="100"
      aria-valuenow="${Math.round(progress)}"
      style="
        display:block;
        width:100%;
        height:6px;
        background:${this.hasAttribute('data-show-alert') ? '#d4d4d4' : '#575554'};
        border-radius:20px;
        overflow:hidden;
      "
    >
      <div style="
        display:block;
        width:${progress}%;
        height:100%;
        background:${shippingSuccess ? '#6094b3' : '#80b6d2'};
        border-radius:20px;
        transition:width 0.35s ease;
      "></div>
    </div>

    <div style="
      display:flex;
      justify-content:space-between;
      gap:12px;
      margin-top:7px;
      font-size:11px;
      line-height:1.4;
      color:${this.hasAttribute('data-show-alert') ? '#333333' : '#ffffff'};
    ">
      <span>${formattedTotal}</span>
      <span>${formattedThreshold}</span>
    </div>

  </div>
`;





if (this.hasAttribute('data-show-alert')) {
  this.innerHTML = `
    <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
      ${progressMarkup}
    </div>`;
} else {
  this.innerHTML = progressMarkup;
}


    }
    
    #formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') === 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}